import { useEffect } from "react";

/**
 * Resets scroll position to top when the iOS virtual keyboard closes.
 * iOS shifts the viewport when the keyboard opens — this corrects the
 * scroll offset after the user dismisses the keyboard (focusout fires).
 */
const useKeyboardScrollReset = () => {
  useEffect(() => {
    const handleFocusOut = () => {
      setTimeout(() => {
        const active = document.activeElement;
        // Only reset if focus returned to body/html - meaning the keyboard was fully dismissed.
        // Skips the reset when the user just tabs between input fields.
        if (!active || active === document.body || active.tagName === "HTML") {
          window.scrollTo({ top: 0, behavior: "auto" as ScrollBehavior });
        }
      }, 150);
    };
    document.addEventListener("focusout", handleFocusOut);
    return () => document.removeEventListener("focusout", handleFocusOut);
  }, []);
};

export default useKeyboardScrollReset;
